Browser = require 'lib/browser'
f = require 'effing'
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
t = require('views/internal/recup-with-helpers')()
TFM = require 'lib/markdown/tfm'
track = require 'debug/track'

module.exports = class extends React.Component
  displayName: 'BoardListAnnouncementComponent'
  render: t.renderable ->
    { icon, message, onClick, onDismiss } = @props

    t.div '.boards-page-announcement-container', { onClick: onClick }, ->
      t.div '.boards-page-announcement', ->
        t.icon icon
        t.text ' '
        t.raw TFM.description.formatInline(message)

        t.div '.boards-page-announcement-dismiss', { onClick: onDismiss }, ->
          t.icon 'close'


  shouldComponentUpdate: naiveShouldComponentUpdate



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-announcement-component.coffee